var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownLiner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7961 8.64479C13.0974 8.39376 13.1381 7.94606 12.887 7.64482C12.636 7.34359 12.1883 7.30289 11.8871 7.55392L12.3416 8.09936L12.7961 8.64479ZM9.15959 10.751L8.70506 11.2965C8.96836 11.5159 9.35082 11.5159 9.61412 11.2965L9.15959 10.751ZM6.43211 7.55392C6.13088 7.30289 5.68318 7.34359 5.43215 7.64482C5.18112 7.94606 5.22182 8.39376 5.52305 8.64479L5.97758 8.09936L6.43211 7.55392ZM12.3416 8.09936L11.8871 7.55392L8.70506 10.2056L9.15959 10.751L9.61412 11.2965L12.7961 8.64479L12.3416 8.09936ZM9.15959 10.751L9.61412 10.2056L6.43211 7.55392L5.97758 8.09936L5.52305 8.64479L8.70506 11.2965L9.15959 10.751ZM16.2 8.9998H15.49C15.49 12.5841 12.5843 15.4898 8.99999 15.4898V16.1998V16.9098C13.3686 16.9098 16.91 13.3684 16.91 8.9998H16.2ZM8.99999 16.1998V15.4898C5.41566 15.4898 2.50999 12.5841 2.50999 8.9998H1.79999H1.08999C1.08999 13.3684 4.63142 16.9098 8.99999 16.9098V16.1998ZM1.79999 8.9998H2.50999C2.50999 5.41548 5.41566 2.5098 8.99999 2.5098V1.7998V1.0898C4.63142 1.0898 1.08999 4.63123 1.08999 8.9998H1.79999ZM8.99999 1.7998V2.5098C12.5843 2.5098 15.49 5.41548 15.49 8.9998H16.2H16.91C16.91 4.63123 13.3686 1.0898 8.99999 1.0898V1.7998Z",
    fill: "#4D5975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownLiner);
export default __webpack_public_path__ + "static/media/ChevronDownLiner.d8360e09ac1eff296d8e70403d33c893.svg";
export { ForwardRef as ReactComponent };